// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"84641baf","547":"9b9e0c91","561":"9a55f3ba","921":"bf017346"}[chunkId] + ".css";
};